var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7207 1.00001H9.9707L9.67695 0.415631C9.61473 0.290697 9.51888 0.185606 9.40018 0.11218C9.28148 0.0387537 9.14465 -9.46239e-05 9.00508 5.47898e-06H5.4332C5.29395 -0.00052985 5.15736 0.0381736 5.03908 0.111682C4.9208 0.18519 4.82563 0.290529 4.76445 0.415631L4.4707 1.00001H0.720703C0.588095 1.00001 0.460918 1.05268 0.36715 1.14645C0.273382 1.24022 0.220703 1.3674 0.220703 1.50001L0.220703 2.50001C0.220703 2.63261 0.273382 2.75979 0.36715 2.85356C0.460918 2.94733 0.588095 3.00001 0.720703 3.00001H13.7207C13.8533 3.00001 13.9805 2.94733 14.0743 2.85356C14.168 2.75979 14.2207 2.63261 14.2207 2.50001V1.50001C14.2207 1.3674 14.168 1.24022 14.0743 1.14645C13.9805 1.05268 13.8533 1.00001 13.7207 1.00001ZM1.8832 14.5938C1.90705 14.9746 2.07513 15.332 2.35322 15.5932C2.63131 15.8545 2.99852 16 3.38008 16H11.0613C11.4429 16 11.8101 15.8545 12.0882 15.5932C12.3663 15.332 12.5344 14.9746 12.5582 14.5938L13.2207 4.00001H1.2207L1.8832 14.5938Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.183652631dbe7e6d7cc40eac327d0463.svg";
export { ForwardRef as ReactComponent };